import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "claasFileSize",
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  private readonly units = ["B", "KB", "MB", "GB", "TB", "PB"];

  transform(
    bytes: string | number | null | undefined,
    precision: number = 2,
  ): string {
    if (typeof bytes === "string") {
      bytes = parseInt(bytes, 10);
    }

    if (bytes === null || bytes === undefined || isNaN(bytes)) {
      return "0 B";
    }

    if (bytes === 0) {
      return "0 B";
    }

    const isNegative = bytes < 0;
    const absoluteBytes = Math.abs(bytes);

    const exponent = Math.min(
      Math.floor(Math.log(absoluteBytes) / Math.log(1024)),
      this.units.length - 1,
    );

    const size = absoluteBytes / Math.pow(1024, exponent);
    const formattedSize = size.toFixed(precision);

    return `${isNegative ? "-" : ""}${formattedSize} ${this.units[exponent]}`;
  }
}
